/** Settings copy, English only (one strings file per area, as in the shell). */
export const t = {
  title: "Settings",
  intro: "Set the gym up once, change it safely.",
  retry: "Retry",
  save: "Save changes",
  saving: "Saving…",
  saved: "Saved",
  discard: "Discard",
  cancel: "Cancel",
  loadMore: "Load more",
  back: "← Settings",
  notConnected: "Not connected yet",
  notConnectedBody: (what: string) => `${what} is not available on this server yet.`,
  noAccess: "You don't have access to this",
  noAccessBody: "Ask the owner to give your role access, or go back to Home.",
  dirty: { title: "Discard your changes?", body: "You have unsaved changes on this page. If you leave now they are lost.", stay: "Keep editing", leave: "Discard and leave" },
  validation: "Fix the highlighted fields.",
  conflict: "This changed since you opened it. Reload and try again.",
  groups: { gym: "Your gym", sell: "What you sell", people: "People and access", leads: "Leads and messages", devices: "Devices and records", you: "You" },
  sections: {
    business: { title: "Business", body: "Name, currency, timezone and tax." },
    branches: { title: "Brands and branches", body: "Locations, hours, GSTIN and addresses." },
    invoicing: { title: "Invoicing", body: "Legal name and invoice numbering." },
    memberships: { title: "Memberships", body: "Freeze limits and fees." },
    commission: { title: "Commission", body: "How trainer commission is decided." },
    payroll: { title: "Payroll", body: "Contractor TDS." },
    leads: { title: "Leads", body: "Follow-up timing, owners and assignment." },
    attendance: { title: "Attendance", body: "Staff shift and day rules." },
    ptSchedule: { title: "PT booking", body: "How PT packs are booked, and automatic marking." },
    holidays: { title: "Holidays", body: "Days a branch is closed." },
    catalogue: { title: "Plans and catalogue", body: "Memberships, packs, services and products." },
    coupons: { title: "Coupons", body: "Discount codes." },
    paymentAccounts: { title: "Payment accounts", body: "Where online payments are received." },
    roles: { title: "Roles", body: "Who can do what." },
    leadStages: { title: "Lead stages", body: "Your lead pipeline." },
    intakeKeys: { title: "Lead intake keys", body: "Connect a website or ad form." },
    devices: { title: "Devices", body: "Check-in kiosks and signing keys." },
    audit: { title: "Audit log", body: "Who changed what." },
    messaging: { title: "Messaging", body: "WhatsApp pause switch, templates and health." },
    profile: { title: "Profile", body: "Your name and sign-out." },
  },
} as const;
